window.ontech = window.ontech || {};

window.ontech.AccordionTags = function (accordionInfo) {
    let productHandleOnTech = ontech.state.get(State.Settings.PRODUCT_HANDLE);
    sendAnalytics(accordionInfo,{
        [DataModel.PAGE_TYPE]: "product",
        [DataModel.PRODUCT_CATEGORY]: "Product",
        [DataModel.PRODUCT_ID]: [window.__shgProducts[productHandleOnTech].id],
        [DataModel.PRODUCT_NAME]: [window.__shgProducts[productHandleOnTech].title],
        [DataModel.PRODUCT_BRAND]: [window.__shgProducts[productHandleOnTech].vendor],
        [DataModel.PRODUCT_PRICE]: [window.__shgProducts[productHandleOnTech].price / 100.0],
        [DataModel.PRODUCT_SKU]: [window.__shgProducts[productHandleOnTech].variants[0].sku],
        [DataModel.VARIANT_ID]: [window.__shgProducts[productHandleOnTech].variants[0].id],
        [DataModel.MEMBERSHIP_EXISTING]: ontech.state.get(State.Membership.IS_MEMBER),
        [DataModel.CUSTOMER_LOGGED_IN]: ontech.state.get(State.Customer.IS_LOGGED_IN),
        [DataModel.PAGE_TYPE]: "product_detail_page"
    })
}